import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'firstStep', 'secondStep', 'thirdStep', 'fourthStep', 'fithStep', 'paymentPhone', 'phoneError', 'step', 'paymentBusyStep', 'paymentForm', 'paymentButton', 'paymentOption', 'publicReference', "labelMobile", "labelAmanata", "labelNitaOnline", "labelOther", "loaderMobile", "loaderAmanata", "loaderNitaOnline", "loaderNitaCode", "loaderOther", "paymentText", "nitaCode" ];

  connect() {
    this.currentStep = this.data.get('step');
    this.updatePaymentOption();
    let feeErrorTarget = document.querySelector('#feeError')
    if (this._isValidFee()) {
      feeErrorTarget.classList.add('d-none');
      this.element.classList.remove('d-none')
    }
    else {
      this.element.classList.add('d-none')
      feeErrorTarget.classList.remove('d-none');
    }
  }

  updatePaymentOption(e) {
    let selectedOption;
    if (e) {
      selectedOption = e.currentTarget.getAttribute("for");
    } else {
      const checkedInput = this.element.querySelector('input[name="payment-option"]:checked');
      selectedOption = checkedInput ? checkedInput.value : null;
      if (!selectedOption) {
        const firstEnabledInput = this.element.querySelector('input[name="payment-option"]:not([disabled])');
        selectedOption = firstEnabledInput ? firstEnabledInput.value : "mobile";
      }
    }
    this.paymentOption = selectedOption; 
  
    const fee = this.data.get("fee"); 
    let buttonText;
  
    switch (selectedOption) {
      case "mobile":
        buttonText = `Payer ${fee} FCFA via Mobile Money`;
        break;
      case "amanata":
        buttonText = `Payer ${fee} FCFA avec Amanata`;
        break;
      case "alizza":
        buttonText = `Générer un code de paiement`;
        break;
      case "nita_online":
        buttonText = `Générer un code de paiement`;
        break;
      default:
        buttonText = `Payer ${fee} FCFA`;
    }
  
    this.paymentTextTarget.textContent = buttonText;
  
    this._hideAll();
    
    if (selectedOption === "mobile" && this.hasLabelMobileTarget) {
      this.labelMobileTarget.classList.remove("is-hidden");
      this.loaderMobileTarget.classList.remove("is-hidden");
    } else if (selectedOption === "amanata" && this.hasLabelAmanataTarget) {
      this.labelAmanataTarget.classList.remove("is-hidden");
      this.loaderAmanataTarget.classList.remove("is-hidden");
    } else if (selectedOption === "alizza" && this.hasLabelOtherTarget) {
      this.labelOtherTarget.classList.remove("is-hidden");
      this.loaderOtherTarget.classList.remove("is-hidden");
    } else if (selectedOption === "nita_online" && this.hasLabelNitaOnlineTarget) {
      this.labelNitaOnlineTarget.classList.remove("is-hidden");
      this.loaderNitaOnlineTarget.classList.remove("is-hidden");
    }
  }
  

  _hideAll() {
    if (this.hasLabelMobileTarget) this.labelMobileTarget.classList.add("is-hidden");
    if (this.hasLabelAmanataTarget) this.labelAmanataTarget.classList.add("is-hidden");
    if (this.hasLabelNitaOnlineTarget) this.labelNitaOnlineTarget.classList.add("is-hidden");
    if (this.hasLabelOtherTarget) this.labelOtherTarget.classList.add("is-hidden");

    if (this.hasLoaderMobileTarget) this.loaderMobileTarget.classList.add("is-hidden");
    if (this.hasLoaderAmanataTarget) this.loaderAmanataTarget.classList.add("is-hidden");
    if (this.hasLoaderNitaOnlineTarget) this.loaderNitaOnlineTarget.classList.add("is-hidden");
    if (this.hasLoaderNitaCodeTarget) this.loaderNitaCodeTarget.classList.add("is-hidden");
    if (this.hasLoaderOtherTarget) this.loaderOtherTarget.classList.add("is-hidden");
  }

  backToStepOne() {
    this._displayStep('first');
  }

  backToStepTwo() {
    this._displayStep('second');
  }

  backToStepThree() {
    this._displayStep('third');
  }

  backToStepFour() {
    this._displayStep('fourth');
  }

  backToStepFive() {
    this._displayStep('fith');
  }

  createPayment(e) {
    e.preventDefault();
    if (this._isValidPhone()) {
      this._submitPayment()
    }
    else {
      this.phoneErrorTarget.classList.remove('d-none');
    }
  }

  createBulkPayment(e) {
    e.preventDefault();
    // this.paymentOption = 'alizza'; 
    if (this._witch_check()) {
      this._submitPayment()
    }
    else {
      this.phoneErrorTarget.classList.remove('d-none');
    }
  }

  _submitPayment() {
    this.phoneErrorTarget.classList.add('d-none');
    this.paymentButtonTarget.setAttribute('disabled', true);

    fetch(`${this.data.get('url')}?payment_phone=${this.paymentPhoneTarget.value}&payment_provider=${this.paymentOption}`)
    .then(response => response.json())
    .then(data => {
      if (this.paymentOption == 'alizza') {
        this.publicReferenceTarget.textContent = data['payment']['public_reference'];
      } else if (this.paymentOption == 'nita_online') {
        if (this.hasNitaCodeTarget && data['payment']['meta_data'] && data['payment']['meta_data']['code']) {
          this.nitaCodeTarget.textContent = data['payment']['meta_data']['code'];
          this.loaderNitaCodeTarget.classList.remove('is-hidden');
        }
      }
      this.paymentFormTarget.classList.add('d-none');
      this.paymentBusyStepTarget.classList.remove('d-none');
    })
  }

  _isValidPhone() {
    let phoneFormat = /^(96|97|98|99|87|88|89|76|77|78|74|75|76|84|85|94|95|70|80|81|90|91|92|86)[0-9]{6}$/;
    return this.paymentPhoneTarget.value.match(phoneFormat);
  }

  _displayCurrentStep() {
    if (this.currentStep ==  '1') {
      this._displayStep('first');
    }
    else if (this.currentStep ==  '2') {
      this._displayStep('second');
    }
    else if (this.currentStep ==  '3') {
      this._displayStep('third');
    }
    else if (this.currentStep ==  '4') {
      this._displayStep('fourth');
    }
    else if (this.currentStep ==  '5') {
      this._displayStep('fith');
    }
    else if (this.currentStep ==  '6') {
      this._displayStep('sixth');
    }
  }

  _displayStep(step) {
    this.stepTargets.forEach(elt => elt.classList.add('d-none'));
    this[`${step}StepTarget`].classList.remove('d-none');
  }

  _witch_check(){
    if (this.paymentOption == 'mobile') {
      let phoneFormat = /^(96|97|98|99|87|88|89|76|77|78|74|75|76|84|85|94|95)[0-9]{6}$/;
      return this.paymentPhoneTarget.value.match(phoneFormat) != null;
    } else {
      return this._isValidPhone()
    }
  }

  _isValidFee(){
    return 1000000  >= this.data.get('fee')
  }
}